import { render, staticRenderFns } from "./AppClearFiltersButton.vue?vue&type=template&id=53dac0c4&scoped=true&"
import script from "./AppClearFiltersButton.vue?vue&type=script&lang=js&"
export * from "./AppClearFiltersButton.vue?vue&type=script&lang=js&"
import style0 from "./AppClearFiltersButton.vue?vue&type=style&index=0&id=53dac0c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dac0c4",
  null
  
)

export default component.exports